<template>
	<b-modal id="work-zone-report-modal" ref="workZoneModalRef" title="Time in Zone Type Summary Report" class="" :class="" centered size="lg">

		<div class="table-wrapper">
			<table class="table table-striped table-hover">
				<thead>
				<tr>
					<th>Date</th>
					<th>Planning Zone</th>
					<th>Work Zone</th>
					<th>Break Zone</th>
					<th>Travel Time</th>
				</tr>
				</thead>
				<tbody>
					 <tr v-for="n in day">
						 <td>Day {{ n }}</td>
						 <td>
							 {{ $number.format(planning_time[n - 1] || 0) }}%
						 </td>
						 <td>
							 {{ $number.format(work_time[n - 1] || 0) }}%
						 </td>
						 <td>
							 {{ $number.format(break_time[n - 1] || 0) }}%
						 </td>
						 <td>
							 {{ $number.format(travel_time[n - 1] || 0) }}%
						 </td>
					 </tr>

				</tbody>
			</table>
		</div>

		<div slot="modal-footer">
			<b-btn type="button" class="btn btn-dark pl-4 pr-4" @click="$refs.workZoneModalRef.hide()">Close</b-btn>
		</div>

	</b-modal>
</template>
<script>
	export default {
		name: 'WorkZoneReport',
		computed: {
			log() { return this.$store.state.log },
			day() { return this.$store.state.day },
			travel_time() {
				return this.$store.state.report.travel_time || [];
			},
			work_time() {
				return this.$store.state.report.zone_time.work || [];
			},
			planning_time() {
				return this.$store.state.report.zone_time.planning || [];
			},
			break_time() {
				return this.$store.state.report.zone_time.break || [];
			}
		}
	}
</script>